import { onMounted, Ref, ref, onBeforeUnmount } from "@vue/composition-api";
import { isFirefox, isEdge } from "@web-components/common/browser";

const INTERVAL_LENGTH = 50;

//Edge and Firefox do not trigger change events to input fields upon autofill..
//Firefox does not dispatch change event on autofill. So for firefox we are forced to poll to see if the DOM has changed
//Edge changes class attribute edge-autofill, which means we can use a MutationObserver to monitor changes to the DOM

export const useAutoFillFix = (
  inputValue: Ref<string>,
  changeEventHandler: (value: string) => void
) => {
  const inputRef: Ref<HTMLInputElement | null> = ref(null);

  const performUpdateIfRequired = () => {
    if (inputRef.value && inputRef.value.value !== inputValue.value) {
      changeEventHandler(inputRef.value.value);
    }
  };

  let interval: number | undefined;
  let observer: MutationObserver | undefined;

  const setUpFireFox = () => {
    interval = window.setInterval(performUpdateIfRequired, INTERVAL_LENGTH);
  };

  const setUpEdge = () => {
    const config: MutationObserverInit = {
      attributes: true,
      characterData: true,
    };

    observer = new MutationObserver(performUpdateIfRequired);

    if (inputRef.value) {
      observer.observe(inputRef.value, config);
    }
  };

  onMounted(() => {
    if (isEdge()) {
      setUpEdge();
    } else if (isFirefox()) {
      setUpFireFox();
    }
  });

  onBeforeUnmount(() => {
    if (observer) {
      observer.disconnect();
    }
    if (interval) {
      clearInterval(interval);
    }
  });

  return {
    inputRef,
  };
};
